/**
 *  Enum trạng thái sao lưu dữ liệu
 * ndhieu3 24.04.2023
 */
export default {
  Pending: 0,          // Chờ xử lý, chưa được worker nhận
  BackupSuccessful: 1, // Sao lưu thành công
  BackingUp: 2,        // Đang sao lưu
  BackupFailed: 3,     // Sao lưu thất bại
  OverdueRecovery: 4,  // Quá hạn phục hồi
  CancelBackup: 5,     // Đang bấm hủy sao lưu
  WaitingRestore: 6,   // Đang phục hồi dữ liệu
  CancelRestore: 7,    // Đang bấm hủy khôi phục
};
